/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2024 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */
import React from 'react';
import type { TimeSeriesService } from '@opengeoweb/shared';
import { TimeSeriesConnectWrapper } from '../TimeSeries/TimeSeriesConnectWrapper';
import type { PlotPreset } from '../TimeSeries/types';

// This is a copy of InitialTimeSeriesProps in libs/core/src/lib/components/ComponentsLookUp/componentsLookUp.tsx
interface InitialTimeseriesProps {
  plotPreset: PlotPreset;
  services: TimeSeriesService[];
  hideLocationMarkers?: boolean;
  syncGroupsIds: string[];
}

export type SupportedComponentTypes = 'TimeSeries';

export type InitialProps = InitialTimeseriesProps;

export interface ComponentsLookUpPayload {
  componentType: SupportedComponentTypes;
  id: string;
  title?: string;
  initialProps: InitialProps;
}

/**
 * The lookup table is for registering your own components with the workspace.
 * @param payload
 * @returns
 */
export const componentsLookUp = ({
  id: panelId,
  componentType,
  initialProps,
}: ComponentsLookUpPayload): React.ReactElement => {
  switch (componentType) {
    case 'TimeSeries': {
      return (
        <TimeSeriesConnectWrapper
          hideLocationMarkers={initialProps.hideLocationMarkers}
          panelId={panelId}
          timeSeriesPreset={{
            plotPreset: initialProps.plotPreset,
            services: initialProps.services,
            syncGroupsIds: initialProps.syncGroupsIds,
          }}
        />
      );
    }
    default:
      return null!;
  }
};
